<footer>
    <div class="h-[5px] w-full bg-[#73121a]"></div>

    <div class="bg-dark p-7 text-light flex flex-col gap-7">
        <div class="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3">
            <div class="hidden lg:block self-center justify-center">
                <img class="mx-auto" src="assets/images/verygames.png" alt="VeryGames Logo">
            </div>
            <div class="self-center justify-center">
                <div class="grid grid-cols-2">
                    <div *ngIf="dynamicDatas[DYNAMIC_DATA.GAMES]" class="text-center items-center flex flex-col gap-1">
                        <vl-icon status="light" size="3xl" pack="font-awesome-solid" icon="gamepad"></vl-icon>
                        <p class="font-medium">
                            {{ dynamicDatas[DYNAMIC_DATA.GAMES] }}
                            <span i18n="@@footer.games" class="text-sm">Games</span>
                        </p>
                    </div>
                    <div *ngIf="dynamicDatas[DYNAMIC_DATA.DATACENTERS]" class="text-center items-center flex flex-col gap-1">
                        <vl-icon status="light" size="3xl" pack="font-awesome-solid" icon="server"></vl-icon>
                        <p class="font-medium">
                            {{ dynamicDatas[DYNAMIC_DATA.DATACENTERS] }}
                            <span i18n="@@footer.datacenters" class="text-sm">Datacenters</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="flex self-center justify-evenly gap-4">
                <a *ngFor="let socialLink of socialLinks" [href]="socialLink.url" class="text-3xl text-white hover:text-secondary transition-colors duration-200">
                    <i [ngClass]="socialLink.icon"></i>
                </a>
            </div>
        </div>

        <hr class="bg-white">

        <div class="container max-w-6xl mx-auto">
            <div class="text-center grid grid-cols-1 justify-items-center gap-7 sm:grid-cols-2 md:text-left md:grid-cols-3">

                <div class="flex flex-col gap-2">
                    <h3 class="uppercase text-lg text-primary font-medium" i18n="@@footer.game_server">Game Server</h3>
                    <div class="flex flex-col gap-2">
                        <a *ngFor="let product of products.game_servers" [routerLink]="['/product/', seoUrl(product)]" class="text-sm hover:text-secondary transition-colors duration-200 cursor-pointer">
                            {{ product.name }}
                        </a>
                    </div>
                </div>

                <div class="flex flex-col gap-2">
                    <h3 class="uppercase text-lg text-primary font-medium" i18n="@@footer.access">Access</h3>
                    <div class="flex flex-col gap-2">
                        <a [routerLink]="['/my-account/', 'profile']" class="text-sm hover:text-secondary transition-colors duration-200 cursor-pointer" i18n="@@footer.my_profile">My Profile</a>
                        <a [routerLink]="['/my-account/', 'ticket']" class="text-sm hover:text-secondary transition-colors duration-200 cursor-pointer" i18n="@@footer.support">Support</a>
                    </div>
                </div>

                <!-- <div class="flex flex-col gap-2">
                    <h3 class="uppercase text-lg text-primary font-medium" i18n="footer languages and currencies label|The languages and currencies label of the footer@@vg.footer.languagesandcurrencies.label">
                        Languages & Currencies
                    </h3>
                    <div class="flex flex-col gap-2">
                        <currency-and-language display="BOTH" class="text-sm hover:text-secondary transition-colors duration-200 cursor-pointer"></currency-and-language>
                    </div>
                </div> -->

                <div class="flex flex-col gap-2">
                    <h3 class="uppercase text-lg text-primary font-medium" i18n="@@footer.means_of_payment">Means of Payment</h3>
                    <div class="flex flex-col gap-2">
                        <ng-container *ngFor="let paymentType of paymentTypes | slice:0:2">
                            <img *ngIf="paymentType?.file_medias?.marketing?.MAIN" class="mx-auto md:mx-0 transition-all duration-300 !max-w-[150px]" [src]="paymentType?.file_medias?.marketing?.MAIN | SafeImageLoader | async">
                            <span class="text-sm" *ngIf="!paymentType?.file_medias?.marketing?.MAIN"> {{ paymentType?.name }}</span>
                        </ng-container>

                        <span *ngIf="paymentTypes?.length > 2" class="text-sm hover:text-secondary transition-colors duration-200 cursor-pointer" (click)="offcanvasAllPayments.open()">+{{ paymentTypes?.length - 2 }} <ng-container i18n="@@footer.more">More</ng-container></span>

                        <!-- <vl-icon *ngIf="paymentTypes?.length > 2" class="mx-auto cursor-pointer" (click)="offcanvasAllPayments.open()" status="light" size="4xl" pack="font-awesome-solid" icon="chevron-circle-down"></vl-icon> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-center sm:text-left p-4 bg-dark-950 grid grid-cols-1 sm:grid-cols-2 text-light text-xs">
        <div i18n="@@footer.copyright" i18n="@@footer.copyright">Copyright (C) 2024, VeryGames SARL, All rights reserved</div>
        <div class="sm:ml-auto space-x-2">
            <a routerLink="legal-notice" class="hover:text-primary transition-colors duration-200" i18n="@@footer.legal_notice">Legal Notice</a> <span>-</span>
            <a href="https://www.verygames.net/files/cgv_en.pdf" target="_blank" class="hover:text-primary transition-colors duration-200" i18n="@@footer.tos">Terms and Conditions of Sales</a>
        </div>
    </div>
</footer>

<vg-offcanvas #offcanvasAllPayments>
    <vg-offcanvas-header>
        <h5 i18n="@@footer.means_of_payment_canvas">Means of payment</h5>
    </vg-offcanvas-header>
    <vg-offcanvas-body class="text-center flex flex-col items-center">
        <ng-container *ngFor="let paymentType of paymentTypes">
            <img *ngIf="paymentType.file_medias?.marketing?.MAIN" class="my-2 !max-w-[150px]" [src]="paymentType.file_medias.marketing.MAIN | SafeImageLoader | async">
            <h2 *ngIf="!paymentType.file_medias?.marketing?.MAIN" class="my-2 align-self-center"> {{ paymentType?.name }}</h2>
        </ng-container>
    </vg-offcanvas-body>
</vg-offcanvas>